<template>
    <div class="card-container">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "CardContainer"
}
</script>

<style scoped lang="less">
.card-container {
    min-height: 500px;
    background: white;
    border-radius: 16px;
    overflow: auto;
}
</style>
